module.exports = __webpack_public_path__ + "1e42ed973538d201b836c1ab1630b272.svg";